import handleActions from 'redux-actions/lib/handleActions'
import reduce from './reduce'

const { assign, values } = Object

const createReducer = (state, types, reducers) => {
  const actions = reduce(types, (obj, key, idx) =>
    assign(obj, { [key]: values(reducers)[idx] }), {})

  return handleActions(actions, state)
}

export default createReducer
